import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { SofaButton } from '@sofology/sofologycomponents';

import './BasketDonation.scss';

import { BasketDetailsModel, DonationModel } from 'models/Basket';
import { Donated } from './Donated/Donated';
import { generateCharityImgPath, generateDispatchToPropsMap } from 'helpers';
import { AppState } from 'store';
import { AddDonationFunc, addDonation, LoadDonationFunc, loadDonation } from 'store/basket/actions';

const BASKET_PENNIES_LOGO_ID = '00000000';
const DEFAULT_CHARITY_INDEX = 0;
const DEFAULT_QTY = 1;

const BASKET_DONATION_BUTTONS = [
    {
        title: 'Donate £1',
        sku: 'pennies1'
    },
    {
        title: 'Donate £5',
        sku: 'pennies5'
    },
    {
        title: 'Donate £10',
        sku: 'pennies10'
    }
];

interface StateProps {
    basket: BasketDetailsModel;
    isDonationLoading: boolean;
    donation: DonationModel | null;
}

interface DispatchProps {
    loadDonation: LoadDonationFunc;
    addDonation: AddDonationFunc;
}

class BasketDonation extends Component<StateProps & DispatchProps> {
    componentDidMount(): void {
        this.props.loadDonation();
    }

    handleDonationClick = (sku: string) => () => {
        this.props.addDonation(sku, DEFAULT_QTY);
    };

    render(): JSX.Element {
        const { basket, donation, isDonationLoading } = this.props;
        const hasDonation = basket.hasDonationProduct();

        const charity = (donationIsNotEmpty(donation)
            && donation!.charities![DEFAULT_CHARITY_INDEX]) || undefined;

        return (
            <>
                {
                    ((hasDonation || isDonationLoading) && <Donated charity={charity} thankYouImageSize={this.isNameIncludesCancer() ? undefined : '100'} />)
                    || this.renderContent()
                }
            </>
        );
    }

    renderContent(): JSX.Element {
        const { donation } = this.props;

        return (
            <>
                {
                    donationIsNotEmpty(donation) && <div dangerouslySetInnerHTML={{
                        __html: this.isNameIncludesCancer() ?
                            this.renderByName() :
                            this.renderByDescription()
                    }} />
                }
                {this.renderButtons()}
                <div className='pennies__charity-type'>
                    {
                        donationIsNotEmpty(donation) &&
                        <div className={`pennies__charity-type__donation${this.isNameIncludesCancer() ? '--by-name' : '--by-description'}`}>
                            {
                                <img
                                    src={generateCharityImgPath(donation!.charities![DEFAULT_CHARITY_INDEX].id)}
                                    alt='Donation logo'
                                    onError={e => {
                                        e.currentTarget.src = donation!.charities![DEFAULT_CHARITY_INDEX].logoUrl ?? '';
                                    }} />
                            }
                        </div>
                    }
                    <div className={`pennies__charity-type__logo${this.isNameIncludesCancer() ? '--by-name' : '--by-description'}`}>
                        <img src={generateCharityImgPath(BASKET_PENNIES_LOGO_ID)} alt='Pennies logo' />
                    </div>
                </div>
            </>
        );
    }

    renderByDescription(): string {
        const { donation } = this.props;

        return (
            `${donation!.charities![DEFAULT_CHARITY_INDEX]!.description}`
        );
    }

    renderByName(): string {
        const { donation } = this.props;

        return (
            `<h3>We've partnered with Pennies to support the incredible work of our nominated charity partners.</h3>
            <p>Every Penny goes to charity; 45% of your donation will go to
            ${donation!.charities![DEFAULT_CHARITY_INDEX]!.name},
            the remaining 10% will go to Pennies (registered charity no. 1122489)</p>`
        );
    }

    renderButtons(): JSX.Element {
        const { isDonationLoading } = this.props;

        return (
            <div className='basket-donation__buttons'>
                {
                    BASKET_DONATION_BUTTONS.map(button => {
                        return (
                            <SofaButton
                                key={button.sku}
                                text={button.title}
                                variant='secondary-rounded'
                                disabled={isDonationLoading}
                                onClick={this.handleDonationClick(button.sku)}
                            />
                        );
                    })
                }
            </div>
        );
    }

    isNameIncludesCancer(): boolean {
        const { donation } = this.props;

        return donationIsNotEmpty(donation) && donation!.charities![DEFAULT_CHARITY_INDEX]!.name.includes('Breast Cancer Now');
    }
}

function donationIsNotEmpty(donation: DonationModel | null): boolean {
    return Boolean(donation?.charities?.length);
}

function mapStateToProps(state: AppState): StateProps {
    return {
        basket: state.basketState.basket!,
        isDonationLoading: state.basketState.isDonationLoading,
        donation: state.basketState.donation
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [loadDonation, addDonation]);
}

export default connect(mapStateToProps, mapDispatchToProps)(BasketDonation);